import React, { useState } from 'react';
import HomeMainContent from '../../Components/HomeComponents/HomeMainContent';
import HomeSideBar from '../../Components/HomeComponents/HomeSideBar';
import { useGetTasksQuery } from '../../features/tasks/tasksApi';

const Home = () => {

    return (
        <div className="container relative">
            <HomeSideBar>
            </HomeSideBar>
            <HomeMainContent ></HomeMainContent>
        </div>
    );
};

export default Home;